import Chip from 'components/@extended/Chip';
import { Tooltip } from 'components/ui/tooltip';
import { OpponentCaseState } from 'types/contacts';
import { t } from 'utils/getTranslations';

const MARKER = {
    IN_PROGRESS: { type: 'opponentOngoing', tooltip: 'contacts.opponent-in-progress-matter' },
    COMPLETED: { type: 'opponentCompleted', tooltip: 'contacts.opponent-completed-matter' },
} as const satisfies Record<OpponentCaseState, { type: string; tooltip: string }>;

interface Props {
    state?: OpponentCaseState | null;
}

/**
 * The "Op" marker of a contact that stands as an opponent on a case. The backend has already resolved the
 * strongest state, and returns none while the OPPONENT_CHIP setting is off, so this renders whatever it is
 * given.
 */
export function OpponentChip({ state }: Props) {
    if (!state) return null;
    const { type, tooltip } = MARKER[state];
    return (
        <Tooltip side="bottom" content={t(tooltip)}>
            <span className="inline-flex align-middle">
                <Chip size="small" type={type} label="Op" />
            </span>
        </Tooltip>
    );
}
